export default "__VITE_PUBLIC_ASSET__af18b196__"